angular.module('impactx.MenuDirectives').controller('MessageInfoCtrl', ['$scope', 'dataGen', '$mdDialog', '$context', 'MessageService', 'TranslationService', MessageInfoCtrl]);

function MessageInfoCtrl($scope, dataGen, $mdDialog, $context, MessageService, TranslationService) {
    var ctrl = this;
    $scope.getInfoMessageCount = MessageService.getInfoMessageCount;
    this.translationService = TranslationService;

    $scope.$watch(function () {
        return $context.$securityManager.isProcessAllowedWatch;
    }, function (newValue) {
        if (newValue) {
            ctrl.visible = $context.$securityManager.isProcessAllowedWatch($scope, "Message", function (newValue) {
                $scope.visible = newValue
            });
        }
    });

    this.show = function (ev) {
        $mdDialog.show({
            controller: "MessageInfoDialogCtrl",
            templateUrl: 'shared/menu/templates/messageinfo.tmpl.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            hasBackdrop: false,
            disableParentScroll: false
        });

    };
}